var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"redesign-extension-card"},[_c('div',[_vm._t("header")],2),_c('div',[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }